// 订单中心
import qs from 'qs'
import port from '@/config/config/orderDetailConnector.js'
export default {
  addressRecognize:params => $network.post('/api/cs/oc/oms/v1/addressRecognize', params), // 智能识别地址

  exportSkuRelease: params => $network.post('/api/cs/md/skuRelease/export', params), // 商品发布-批量导出
  exportOcB2BOrder: params => $network.post('/api/cs/oc/oms/v1/exportOcB2BOrder', params), // 经销/分销/电商平台订单-批量导出
  exportDistribution: params => $network.post('/api/cs/sg/v1/distribution/export', params), // 经销/分销/电商平台/一件代发批量退货单-批量导出
  exportDistributionOrder: params => $network.post('/api/cs/sg/v1/distributionOrder/export', params), // top配货单-批量导出
  exportVipOrder: params => $network.post('/api/cs/vip/delivery/v1/export', params), // 唯品会入库单-批量导出
  exportV2: params => $network.post('/p/cs/exportV2', params), // JIT配货单-批量导出
  /**
   * 零售发货单
   */

  queryAfterSaleApplyOrder: params => $network.post('/api/cs/oc/oms/ocBAfterSaleApplyOrder/query', params), // 新增售后申请单-查询
  saveAfterSaleApplyOrder: params => $network.post('/api/cs/oc/oms/ocBAfterSaleApplyOrder/save', params), // 新增售后申请单-保存
  orderDecrypt: params => $network.get(`/api/cs/oc/oms/v1/orderDecrypt?${qs.stringify(params)}`), // 订单收货地址-解密
  makeUpDiffPriceGetPrice: params => $network.post('/api/cs/oc/oms/v1/makeUpDiffPrice/getPrice', params), // 补差价获取价格
  makeUpDiffPriceConfirm: params => $network.post('/api/cs/oc/oms/v1/makeUpDiffPrice/confirm', params), // 补差价确认
  makeUpDiffPriceDelete: params => $network.post('/api/cs/oc/oms/v1/makeUpDiffPrice/delete', params), // 补差价删除

  getRegionDataSource: params => $network.get(`/api/cs/md/region/getRegionDataSource`),
  naika_void: params => $network.get(`/api/cs/oc/oms/naika/order/void?${qs.stringify(params)}`),
  naika_detail: params => $network.get(`/api/cs/oc/oms/naika/return/detail?${qs.stringify(params)}`),
  selectEqualExchangeOrder: params => $network.post('/api/cs/oc/oms/v1/selectEqualExchangeOrder', params), // 根据订单id查询明细数据
  // api/cs/oc/oms/v1/selectEqualExchange?skuCode = ?
  selectEqualExchange: params => $network.get(`/api/cs/oc/oms/v1/selectEqualExchange?${qs.stringify(params)}`), // 根绝skucode查询对等换货策略信息
  confirmEqualExchange: params => $network.post('/api/cs/oc/oms/v1/confirmEqualExchange', params), // 执行对等换货
  selectExpiryDate: params => $network.post('/api/cs/oc/oms/v1/selectExpiryDate', params),
  autoExpiryDate: params => $network.post('/api/cs/oc/oms/v1/autoExpiryDate', params),
  confirmExpiryDate: params => $network.post('/api/cs/oc/oms/v1/confirmExpiryDate', params),
  orderMarking: params => $network.post('/api/cs/oc/oms/orderMarking', params),
  clearOrderMarking: params => $network.post('/api/cs/oc/oms/clearOrderMarking', params),
  remitFail: params => $network.post('/p/cs/oc/oms/v1/refundExtra/remitFail', params), //退货入库单-匹配保存接口

  checkRefundInStatus: params =>
    $network.get('/p/cs/oc/oms/v1/refundInOrder/checkRefundInStatus?' + params), //退货入库单-判断退货入库单匹配状态

  saveMatch: params => $network.post('/p/cs/oc/oms/v1/refundInOrder/saveMatch', params), //退货入库单-匹配保存接口

  getMathReturnOrderByPage: params =>
    $network.post('/p/cs/oc/oms/v1/refundInOrder/getMathReturnOrderByPage', params), // 退换货单-修改备注

  updateReturnOrderRemark: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/updateReturnOrderRemark', params), // 退换货单-修改备注

  saveOrderByPro: params => $network.post('/p/cs/oc/b/oms/v1/ocborder/saveOrderByPro', params), // 添加订单商品信息-确定添加
  replaceOrderByPro: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocborder/replaceOrderByPro', params), // 替换订单商品-确认按钮

  deleteOrderGoods: params => $network.post('/p/cs/oc/b/oms/v1/ocborder/deleteOrderGoods', params), // 批量删除商品信息-删除按钮
  parseOrderList: params => $network.post('/p/cs/oc/b/oms/v1/ocborder/parseOrderList', params), // 批量解析组合商品-确定解析
  // auditOrder: (params) => $network.post('/p/cs/oc/oms/v1/auditOrder', params), // 审核
  auditOrder: params => $network.post('/api/cs/oc/oms/v1/auditOrder', params), // 审核
  mandatoryAuditOrder: params => $network.post('/api/cs/oc/oms/v1/mandatoryAuditOrder', params), // 强制审核
  mandatoryFinancialAuditOrder: params => $network.post('/api/cs/oc/oms/v1/mandatoryFinancialAuditOrder', params), // 财务审核
  getSeniorQueryCondition: params =>
    $network.post('/api/cs/oc/oms/v1/getSeniorQueryCondition', params), // 高级搜索项
  reallocateLogistics: params => $network.post('/api/cs/oc/oms/v1/reallocateLogistics', params), // 配送物流
  reallocateWarehouse: params => $network.post('/api/cs/oc/oms/v1/reallocateWarehouse', params), // 配送仓库
  getOrderList: params => $network.post('/api/cs/oc/oms/v1/getOrderList', params),
  addTosign: params => $network.post('/p/cs/order/updateWmsSignType/addTosign', params),
  signToadd: params => $network.post('/p/cs/order/updateWmsSignType/signToadd    ', params),
  doBatchReturnOrder: params => $network.post('/api/cs/oc/oms/v1/doBatchReturnOrder', params), // 批量退单
  exportOcBOrder: params => $network.post('/api/cs/oc/oms/v1/exportOcBOrder', params), // 导出
  exportChannel: params => $network.post('/p/cs/export', params), // 导出
  queryImportModelList: (params) => $network.get('/api/cs/oc/oms/pre/v1/getModelList'), //获取导入模板
  queryImportSheetList: (params) => $network.post('/api/cs/oc/oms/pre/v1/getSheetList', params),//获取导入sheet列表
  // auditOrderReserve: (params) =>
  //   $network.post('/p/cs/oc/oms/v1/auditOrderReserve', params), // 反审核
  auditOrderReserveAndDetention: params => $network.post('/api/cs/oc/oms/v1/auditOrderReserveAndDetention', params),
  auditOrderReserve: params => $network.post('/api/cs/oc/oms/v1/auditOrderReserve', params), // 反审核
  updateStatusByIds: params => $network.post('/api/cs/oc/oms/v1/updateStatusByIds', params),
  checkAddOrderInvoicing: params =>
    $network.post('/api/cs/oc/oms/v1/checkAddOrderInvoicing', params),
  checkRecordInvoicing: params => $network.post('/api/cs/oc/oms/v1/checkRecordInvoicing', params), // 开票通知
  checkOrderParam: params => $network.post('/api/cs/oc/oms/invoice/checkOrderParam', params), // 申请发票- 平台单号校验
  // cancelOrder: (params) => $network.post('/p/cs/oc/oms/v1/cancelOrder', params), // 订单取消
  cancelOrder: params => $network.post('/api/cs/oc/oms/v1/cancelOrder', params), // 订单取消
  orderInterception: params => $network.post('/api/cs/oc/oms/v1/orderInterception', params), // 订单拦截
  queryshortagSearchOrder: params =>
    $network.post('/api/cs/oc/oms/v1/queryshortagSearchOrder', params), // 缺货重新占单
  queryFortuneBagShortage: params =>
    $network.post('/api/cs/oc/oms/v1/queryFortuneBagShortage', params), // 福袋缺货重新占单
  doManualDeliveryOrder: params => $network.post('/api/cs/oc/oms/v1/doManualDeliveryOrder', params), // 更改为平台发货
  releaseInventory: params => $network.post('/p/cs/releaseInventory', params), // 释放库存
  // checkOrderBeforeLogistics: (params) =>
  //   $network.post(
  //     '/p/cs/oc/b/oms/v1/ocborder/checkOrderBeforeLogistics',
  //     params
  //   ), // 订单列表-修改物流前校验
  checkOrderBeforeLogistics: params =>
    $network.post('/api/cs/oc/oms/v1/checkOrderBeforeLogistics', params), // 修改物流
  // checkOrderBeforeWarehouse: (params) =>
  //   $network.post(
  //     '/p/cs/oc/b/oms/v1/ocborder/checkOrderBeforeWarehouse',
  //     params
  //   ), // 订单列表-修改仓库前校验
  checkOrderBeforeWarehouse: params =>
    $network.post('/api/cs/oc/oms/v1/checkOrderBeforeWarehouse', params), // 修改仓库
  splitOrder: params => $network.post('/api/cs/oc/oms/v1/splitOrder', params), // 缺货拆单
  // manualUnHoldOrder: (params) =>
  //   $network.post('/p/cs/oc/oms/v2/order/batch/hold/cancel', params), // 零售发货单-取消HOLD单
  manualUnHoldOrder: params => $network.post('/api/cs/oc/oms/v1/manualUnHoldOrder', params), // 审核
  // mergeOrderOne: (params) => $network.post('/p/cs/oc/oms/v1/mergeOrder', params), // 合并订单
  mergeOrderOne: params => $network.post('/api/cs/oc/oms/v1/mergeOrderOne', params), // 合并订单
  // cancelMergeOrder: (params) => $network.post('/p/cs/oc/oms/v1/cancelMergeOrder', params), // 取消合并订单
  cancelMergeOrder: params => $network.post('/api/cs/oc/oms/v1/cancelMergeOrder', params), // 取消合并订单
  batchAddGoods: params => $network.post('/api/cs/oc/oms/v1/batchAddGoods', params), // 零售发货单详情 - 添加赠品
  addGit: params => $network.post('/api/cs/oc/oms/v1/addGit', params),
  bathChangeGoods: params => $network.post('/api/cs/oc/oms/v1/bathChangeGoods', params), // 零售发货单详情 - 替换商品
  replaceSku: params => $network.post('/api/cs/vip/v1/replaceSku', params), // 替换异常商品

  deleteGit: params => $network.post('/api/cs/oc/oms/v1/deleteGit', params),
  checkGit: params => $network.post('/api/cs/oc/oms/v1/checkGit', params),
  markrefund: params => $network.post('/api/cs/oc/oms/v1/markrefund', params),
  orderDetention: params => $network.post('/api/cs/oc/oms/v1/orderDetention', params), // 手动卡单

  markRefundCancel: params => $network.post('/api/cs/oc/oms/v1/markRefundCancel', params),
  modifygoodscheck: params => $network.post('/api/cs/oc/oms/v1/modifygoodscheck', params),
  saveStandards: params => $network.post('/api/cs/oc/oms/v1/saveStandards', params),
  updateIsLackstock: params => $network.post('/api/cs/oc/oms/v1/updateIsLackstock', params),
  // saveAppointSplitOrderInfo: (params) => $network.post('/p/cs/oc/oms/v1/specifySplitOrderInfo', params),
  saveAppointSplitOrderInfo: params =>
    $network.post('/api/cs/oc/oms/v1/saveAppointSplitOrderInfo', params),
  splitBySku: params => $network.post('/api/cs/sg/v1/distribution/splitBySku', params),
  saveSplitOrderInfo: params => $network.post('/api/cs/oc/oms/v1/saveSplitOrderInfo', params),
  confirmSplitOrder: params => $network.post('/api/cs/oc/oms/v1/confirmSplitOrder', params),
  getSingleObjectPermission: params =>
    $network.post('/api/cs/oc/oms/v1/getSingleObjectPermission', params),
  querySkuListAndStorageInfo: params =>
    $network.post('/api/cs/oc/oms/v1/querySkuListAndStorageInfo', params), // 提前判断下该单据是否可拆单
  checkIssuingOrder: params => $network.post('/api/cs/oc/oms/v1/checkIssuingOrder', params), // 提前判断下该单据是否可拆单  店铺渠道=经销渠道不允许拆单
  checkSplitOrder: params => $network.post('/api/cs/oc/oms/v1/checkSplitOrder', params), // 提前判断下该单据是否可拆单 店铺策略“是否允许手工拆单”为否不允许拆单
  getLogisticsInfo: params => $network.post('/api/cs/oc/oms/v1/getLogisticsInfo', params), // 获取物流轨迹
  /**
   * 零售发货单 - 详情
   */
  billCopy: params => $network.post('/api/cs/oc/oms/v1/billCopy', params), // 丢单赋值或复制订单赋值
  queryObject: params => $network.post('/p/cs/oc/oms/v1/queryObject', params), // 获取订单详情
  delOrderItem: params => $network.post('/p/cs/delOrderItem', params), // 删除明细
  queryResionByName: params => $network.post('/api/cs/oc/oms/v1/queryResionByName', params), // 获取省份id
  cancelInterception: params => $network.post('/api/cs/oc/oms/v1/cancelInterception', params), // 取消拦截
  batchDeleteGoods: params => $network.post('/api/cs/oc/oms/v1/batchDeleteGoods', params), // 取消拦截
  selectLimitGroups: params => $network.post('/p/cs/selectLimitGroups', params), // 取消拦截
  initObject: params => $network.post('/p/cs/oc/oms/v1/initObject', params), // 订单详情明细表头
  updateOrderAddr: params => $network.post('/p/cs/oc/oms/v1/updateOrderAddr', params), // 订单详情 - 修改地址
  markCancel: params => $network.post('/p/cs/oc/oms/v1/markCancel', params), // 订单详情 - 修改地址
  selectRegion: params => $network.post('/p/cs/oc/oms/v1/selectRegion', params), // 订单详情 - 修改地址
  getOrderDetailList: params => $network.post('/api/cs/oc/oms/v1/getOrderDetailList', params), // 获取订单详情
  orderUnDeliveryUrgent: params => $network.post('/api/cs/oc/oms/v1/orderUnDeliveryUrgent', params), // 零售发货单 - 批量取消加急
  againOccupyStock: params => $network.post('/api/cs/oc/oms/v1/againOccupyStock', params), // 重新寻源
  checkOtherMergeOrder: params => $network.post('/api/cs/oc/oms/jitx/checkOtherMergeOrder', params), // 是否存在可合并订单
  toBOrderManualMerge: params => $network.post('/api/cs/oc/oms/v1/toBOrderManualMerge', params),
  orderDetentionRelease: params => $network.post('/api/cs/oc/oms/v1/orderDetentionRelease', params), // 卡单释放
  lockStockAndReOccupyStock: params => $network.post('/api/cs/oc/oms/stock/lockStockAndReOccupy', params), // 冻结并重新寻源
  jitxOrderResetShip: params => $network.post('/api/cs/oc/oms/vop/resetShip', params), // JITX重置发货
  resetShipApi: params => $network.post('/api/cs/oc/oms/vop/resetShip', params), // 补发
  /**
   * 扫描入库
   */
  getCurrentBatch: params => $network.post('/api/cs/oc/oms/v1/getCurrentBatch', params), // 获取退货批次数据
  getOneRefundItem: params => $network.post('/api/cs/oc/oms/v1/getOneRefundItem', params), // 获取退换货单号
  cpStoreInfo: params => $network.post('/api/cs/oc/oms/v1/cpStoreInfo', params), // 获取销退入库仓以及批次类型方法
  getScanIncomingInfo: params => $network.post('/api/cs/oc/oms/v1/getScanIncomingInfo', params), // 物流单号，原单单号查询方法
  saveScanIncoming: params => $network.post('/api/cs/oc/oms/v1/saveScanIncoming', params), // 保存 - 扫描

  queryByOrder: params => $network.post('/api/cs/oc/oms/v1/queryByOrder', params), // 选择订单查询
  getScanResult: params => $network.post('/api/cs/oc/oms/v1/getScanResult', params), // 扫描入参查询结果
  getSkuResult: params => $network.post('/api/cs/oc/oms/v1/getSkuResult', params), // 根据商品sku扫描
  createRefundInOrder: params => $network.post('/api/cs/oc/oms/v1/createRefundInOrder', params), // 入库

  getOmniChannelScanResult: params => $network.post('/api/cs/oc/oms/v1/getOmniChannelScanResult', params), // 扫描入参查询结果
  getSkuResult: params => $network.post('/api/cs/oc/oms/v1/getSkuResult', params), // 根据商品sku扫描
  createOmniChannelRefundInOrder: params => $network.post('/api/cs/oc/oms/v1/createOmniChannelRefundInOrder', params), // 入库

  /**
   * 全渠道发货单/自提单
   */
  queryAllSendDetails: params => $network.post('/api/cs/sg/v1/save/queryAllSendDetails', params), // 查询1：全渠道发货单 2: 全渠道自提单
  receivingOrders: params => $network.post('/api/cs/sg/v1/save/receivingOrders', params), // 接单
  ExtractSend: params => $network.post('/api/cs/sg/v1/send/ExtractSend', params), // 发货、核销
  refuseOrder: params => $network.post('/api/cs/sg/v1/refuse/refuseOrder', params), // 拒单
  packing: params => $network.post('/api/cs/sg/v1/save/packing', params), // 去拣货
  queryPacking: params => $network.post('/api/cs/sg/v1/packing/init', params), // 装箱复核-初始
  packingconfirm: params => $network.post('/api/cs/sg/v1/packing/confirm', params), // 装箱复核-确认
  refuseQueryItem: params => $network.post('/api/cs/sg/v1/refuse/queryItem', params), // 拒单-查询条码
  delPackage: params => $network.post('/api/cs/sg/v1/package/del', params), // 装箱复核-删除包裹
  callExpress: params => $network.post('/api/cs/sg/v1/express/call', params), // 装箱复核-呼叫快递
  checkLogisticsDelivery: params => $network.post('/api/cs/sg/v1/logisticsDelivery/check', params), // 生成交接单-前置校验
  createLogisticsDelivery: params => $network.post('/api/cs/sg/v1/logisticsDelivery/create', params), // 生成交接单
  exportExtractSendOrder: params => $network.post('/api/cs/sg/v1/extractSendOrder/export', params), // 批量导出






  /**
   * 额外退款新增/编辑、已发货退款编辑
   */
  saveAfterDeliver: params => $network.post('/api/cs/oc/oms/v1/saveAfterDeliver', params), // 保存
  saveAfterDeliverItem: params => $network.post('/api/cs/oc/oms/v1/saveAfterDeliverItem', params), // 复制页面
  deleteAfterDeliverItem: params =>
    $network.post('/api/cs/oc/oms/v1/deleteAfterDeliverItem', params), // 编辑状态,删除明细
  copyAfterDeliver: params => $network.post('/api/cs/oc/oms/v1/copyAfterDeliver', params), // 详情 复制查询方法
  queryExtraDelItem: params => $network.post('/p/cs/oc/oms/v1/refundExtra/delItem', params), // 额外退款单-明细删除
  createReturnOrder: params => $network.post('/api/cs/oc/oms/v1/createReturnOrder', params), // 已发货退款单-生成退单

  /**
   * 额外退款、已发货退款列表
   */
  DynamicList: params => $network.post('/api/cs/oc/oms/v1/DynamicList', params), // 获取高级查询&表头
  querySalesReturn: params => $network.post('/api/cs/oc/oms/v1/querySalesReturn', params), // 获取列表数据
  virtualWarehouseStorage: params =>
    $network.post('/api/cs/oc/oms/v1/virtualWarehouseStorage', params), // 虚拟仓库入库
  cancelautorefund: params => $network.post('/api/cs/oc/oms/v1/cancelautorefund', params), // 取消自动退款
  updateReturnBOrder: params => $network.post('/api/cs/oc/oms/v1/updateReturnBOrder', params), // 批量原退
  orderReturnRecallFromWms: params =>
    $network.post('/api/cs/oc/oms/v1/orderReturnRecallFromWms', params), // 从wms撤回
  handCancelWms: params => $network.post('/api/cs/oc/oms/v1/cancelWms', params), //
  tonaika: params => $network.post('/api/cs/oc/oms/v1/returnOrder/tonaika', params), //
  markfinish: params => $network.post('/api/cs/oc/oms/v1/returnOrder/markfinish', params),
  retransmissionWms: params => $network.post('/api/cs/oc/oms/v1/retransmissionWms', params), // 重传wms
  forcedCompletion: params => $network.post('/api/cs/oc/oms/v1/forcedCompletion', params), // 强制完成
  exportReturnOrder: params => $network.post('/api/cs/oc/oms/v1/exportReturnOrder', params), // 导出
  findDetail: params => $network.post('/api/cs/oc/oms/v1/findDetail', params), // 获取详情数据
  manualMatchingCheck: params => $network.post('/api/cs/oc/oms/v1/manualMatchingCheck', params), // 验证是否能够进入手工匹配界面
  ocBRefundIn: params => $network.post('/api/cs/oc/oms/v1/ocBRefundIn/invalid', params),
  returnCancel: params => $network.post('/api/cs/oc/oms/v1/returnCancel', params),
  ReturnStorageList: params => $network.post('/api/cs/oc/oms/v1/ReturnStorageList', params),
  exportOcBRefundIn: params => $network.post('/api/cs/oc/oms/v1/exportOcBRefundIn', params),
  ReturnStorageSave: params => $network.post('/api/cs/oc/oms/v1/ReturnStorageSave', params),
  searchButtonsInDetail: params => $network.post('/api/cs/oc/oms/v1/searchButtonsInDetail', params),
  getDetail: params => $network.post('/api/cs/oc/oms/v1/getDetail', params),
  export: params => $network.post('/p/outpro/export', params),
  amendBody: (tableName, params) => $network.post(port[tableName].amendBody, params),
  objectAdd: params => $network.post('/p/cs/objectAdd', params),
  prodel: params => $network.post('/p/cs/prodel', params),
  updateDicunot: params => $network.post('/p/cs/oc/v1/sale/updateDicunot', params),
  updateLogisticsBeforePacking: params =>
    $network.post('/api/cs/vip/distribution/Logistics/v1/updateLogisticsBeforePacking', params),
  sendWmsPick: params => $network.post('/api/cs/vip/distribution//add/sendWmsPick', params),
  checkManualSplit: params => $network.post('/p/cs/oc/oms/v1/checkManualSplit', params), // 提前判断下该单据是否可拆单
  queryManualSplit: params => $network.post('/p/cs/oc/oms/v1/queryManualSplit', params), //手工拆单商品查询
  updateLogistics: params => $network.post('/api/cs/oc/oms/v1/updateLogistics', params), // 零售发货单列表-改物流
  manualMatchingList: params => $network.post('/api/cs/oc/oms/v1/manualMatchingList', params), // 获取退货批次数据
  distributionFindBydistributionId: params =>
    $network.post('/api/cs/vip/distributionItem/v1/findBydistributionId', params), // 根据配货单id查询配货单明细
  distributionChangeTag: params => $network.post('/api/cs/vip/distribution/v1/changeTag', params), // 配货单换吊牌的保存
  // managementOrderHold: (params) => $network.post('/p/cs/oc/oms/v2/order/batch/hold', params), // 零售发货单-HOLD单
  managementOrderHold: params => $network.post('/api/cs/oc/oms/v1/holdOrder', params),
  updateEstimateConTime: params => $network.post('/api/cs/oc/oms/v1/updateEstimateConTime', params), // 零售发货单-HOLD单
  updatePreDeliveryTime: params => $network.post('/api/cs/oc/oms/v1/updatePreDeliveryTime', params), // 零售发货单-周期购预计发货时间修改
  bacthUpdateInsideRemark: params =>
    $network.post('/api/cs/oc/oms/v1/BacthUpdateInsideRemark', params), // 零售发货单-修改内部备注
  updateItemRemark: params => $network.post('/api/cs/oc/oms/v1/updateItemRemark', params), // 零售发货单-订单明细-修改备注

  // returnTypeItemquery: (params) =>
  //   $network.post('/p/cs/objectTableItem', params), // 退款分类-退款分类描述
  extraReturnTableLogQuery: params =>
    $network.get(`/api/cs/oc/oms/v1/getOcBReturnAfSendLog?${qs.stringify(params)}`), // 额外退款单-额外退款单日志
  modifyReturnOrderWarehouse: params =>
    $network.post('/api/cs/oc/oms/v1/modifyReturnOrderWarehouse', params), // 退换货单修改退回仓库
  checkCancelParams: params => $network.post('/api/cs/oc/oms/v1/checkCancelParams', params), // 检查接口
  cancelParams: params => $network.post('/p/cs/oc/oms/v1/returnOrderCancel', params), // 取消接口
  checkBeforeCreateVipDelivery: params =>
    $network.post('/api/cs/vip/distribution/v1/checkBeforeCreateVipDelivery', params), // 创建出仓单初始化接口
  getDeliveryMethod: params =>
    $network.post('/api/cs/vip/distribution/v1/getDeliveryMethod', params), // 创建出仓单获取运输方式
  distributionCreateDelivery: params =>
    $network.post('/api/cs/vip/distribution/v1/distributionCreateDelivery', params), // 创建出仓单接口
  deliveryV1List: params => $network.get(`/api/cs/vip/delivery/v1/list?${qs.stringify(params)}`),
  refund2Exchange: params => $network.post('/api/cs/oc/oms/v1/refund2Exchange', params), // 退货转换货
  exchange2Refund: params => $network.post('/api/cs/oc/oms/v1/exchange2Refund', params), // 批量原退
  returnFillLogistics: params => $network.post('/api/cs/oc/oms/v1/returnFillLogistics', params), // 申请补充物流信息
  refund2ExchangeValidate: params =>
    $network.post('/api/cs/oc/oms/v1/refund2Exchange/before/validate', params), // 退货转换货校验
  getOrderId: params => $network.post('/api/cs/oc/oms/v1/getOrderId', params), // 根据平台单号,查询零售发货单id
  examineTheRefundAfterDelivery: params =>
    $network.post('/api/cs/oc/oms/v1/examineTheRefundAfterDelivery', params), // 额外退款审核
  refuseToPayOcBReturnAfSend: params =>
    $network.post('/api/cs/oc/oms/v1/refuseToPayOcBReturnAfSend', params), // 拒绝打款
  pickOrderExport: params => $network.post('/api/cs/vip/pick/v1/export', params),
  // 半定制弹框
  sync_batch: params => $network.post('/api/cs/sg/full/sync/batch', params),
  updateWarehouse: params => $network.post('/api/cs/oc/oms/v1/updateWarehouse', params), // 订单管理列表-改仓库
  getQueryList: params => $network.post('/api/cs/oc/oms/v1/getQueryList', params),
  reRemarkUpdate: params => $network.post('/api/cs/oc/oms/v1/reRemarkUpdate', params),
  modifyReturnSellerRemark: params =>
    $network.post('/api/cs/oc/oms/v1/modifyReturnSellerRemark', params),
  shortageNotice: params => $network.post('/api/cs/oc/oms/v1/shortageNotice', params),
  validateRefundChange: params => $network.post('/api/cs/oc/oms/v1/validateRefundChange', params), // 退换货单列表效验能否重新生成订单接口

  matchingDelivery: params => $network.post('/api/cs/vip/distribution/v1/matchingDelivery', params),
  generateOutOrder: params => $network.post('/api/cs/vip/delivery/v1/generateOutOrder', params), // JIT仓库管理-生成出仓单
  recordInvoicing: params => $network.post('/api/cs/oc/oms/v1/recordInvoicing', params), // 订单管理-记录发票
  skuListQuery: params => $network.post('/api/cs/md/skuListQuery', params), // 矩阵录入
  updateBeforeWarehouse: params =>
    $network.post('/api/cs/vip/distribution/v1/updateBeforeWarehouse', params), // 修改仓库
  saveOrder: params => $network.post('/api/cs/oc/oms/v1/saveOrder', params), // 修改收货地址
  // 订单管理 - 设置icon
  saveQueryListConfig: params => $network.post('/api/cs/oc/oms/v1/saveQueryListConfig', params),
  queryListConfig: params => $network.post('/api/cs/oc/oms/v1/queryListConfig', params),
  // downloadPick: (params) => $network.post('/p/cs/vip/v2/pick/download', params), // JIT拣货单 (创建拣货单)
  downloadPick: params => $network.post('/api/cs/vip/pick/v1/downloadPick', params), // JIT拣货单 (创建拣货单)
  // JIT配货单(手工占单)
  distributionOccupy: params =>
    $network.post('/api/cs/vip/distribution/v1/distributionOccupy', params),
  vipcomMergeDistribution: params =>
    $network.post('/api/cs/vip/distribution/v1/vipcomMergeDistribution', params),
  generatePoOrder: params => $network.post('/api/cs/vip/po/v1/generatePoOrder', params), // JIT PO单(下载PO单),
  querySgBOutPickorder: params =>
    $network.post('/api/cs/sg/v1/warehouse/sgBOutPickorder/querySgBOutPickorder', params), // JIT PO单(下载PO单), // 出库拣货单查询方法
  saveOutPickOrder: params => $network.post('/api/cs/sg/saveOutPickOrder', params), // 保存
  auditOutPickOrder: params => $network.post('/api/cs/sg/auditOutPickOrder', params), // 审核

  querySgBInPickorder: params =>
    $network.post('/api/cs/sg/v1/warehouse/sgBInPickorder/querySgBInPickorder', params),
  saveInPickOrder: params =>
    $network.post('/api/cs/sg/v1/warehouse/sgBInPickorder/saveInPickOrder', params),
  auditInPickOrder: params =>
    $network.post('/api/cs/sg/v1/warehouse/sgBInPickorder/auditInPickOrder', params), // 审核

  markSureButton: params => $network.post('/api/cs/oc/oms/v1/markSureButton', params), // 手工匹配保存
  forcedMatching: params => $network.post('/api/cs/oc/oms/v1/forcedMatching', params), // 错发强制匹配保存
  seachForced: params => $network.post('/api/cs/oc/oms/v1/seachForced', params), // 错发强制匹配保存
  manualMatchingConfirmationButton: params =>
    $network.post('/api/cs/oc/oms/v1/manualMatchingConfirmationButton', params), // 手工匹配确定
  downloadPO: params => $network.post('/p/cs/vip/v2/po/download', params), // PO单-下载PO单

  /* 2.0: */
  // remarkUpdate: (params) => $network.post('/p/cs/oc/b/oms/v1/ocborder/remarkUpdate', params), // 零售发货单 - 修改备注
  remarkUpdate: params => $network.post('/api/cs/oc/oms/v1/remarkUpdate', params), // 零售发货单 - 修改备注
  initList: params => $network.post('/p/cs/oc/oms/v1/initList', params), // 零售发货单初始化列表接口
  changeTagQuery: params => $network.post('/p/cs/vip/v2/distribution/item/query', params), // 换吊牌-初始化
  changeTagSave: params => $network.post('/p/cs/vip/v2/distribution/change/tag', params), // 换吊牌-保存
  stockGet: params => $network.post('/p/cs/vip/v2/project/stock/in/item/get', params), // 创建入库单-初始化
  stockSave: params => $network.post('/p/cs/vip/v2/distribution/create/delivery/order', params), // 创建入库单-保存
  matchSave: params => $network.post('/p/cs/vip/v2/distribution/match/delivery', params), // 匹配入库单-保存
  customSettings: params => $network.post('/p/cs/oc/oms/v1/customSettings', params), // 排序组件接口汇总
  getStockInDetail: params => $network.post('/p/cs/vip/v2/project/stock/in/item/get', params), // 创建入库单初始化
  stockInSave: params => $network.post('/p/cs/vip/v2/distribution/create/delivery/order', params), // 创建入库单保存
  getMatchDetail: params => $network.post('/p/cs/vip/v2/distribution/get/delivery', params), // 手动匹配入库单初始化
  matchStockInSave: params => $network.post('/p/cs/vip/v2/distribution/match/delivery', params), // 手动匹配入库单保存
  queryList: params => $network.post(`/p/cs/oc/oms/v1/queryList?hash=${+new Date()}`, params), // 查询列表
  queryStatistics: params =>
    $network.post(`/p/cs/oc/oms/v1/queryStatistics?hash=${+new Date()}`, params), // 查询异常数量(tabs标头显示数量)
  getOcBOrderExceptions: params =>
    $network.post('/p/cs/oc/oms/v1/ocborder/getOcBOrderExceptions', params), // 异常数据列表查询
  batchSaveOcBOrderException: params =>
    $network.post('/p/cs/oc/oms/v1/ocborder/batchSaveOcBOrderException', params), // 异常数据处理
  billOcBOrderCopy: params => $network.post('/p/cs/oc/oms/v1/billOcBOrderCopy', params), // 零售发货单-复制-初始化主表信息
  billOcBOrderItemCopy: params => $network.post('/p/cs/oc/oms/v1/billOcBOrderItemCopy', params), // 零售发货单-复制-初始化子表信息
  // queryResionByNames: params => $network.post('/r3-cp/p/cs/cp/v1/region/v1/queryRegionByName', params), // 零售发货单-新增/复制-智能地址赋值-查询省市区
  queryResionByNames: params =>
    $network.post('/p/cs/md/v1/region/v1/queryRegionByName', params, {
      serviceId: 'r3-cp'
    }), // 零售发货单-新增/复制-智能地址赋值-查询省市区
  // saveBill: (params) => $network.post('/p/cs/oc/b/oms/v1/ocborder/saveBill', params), // 零售发货单-新增/复制-保存
  saveBill: params => $network.post('/api/cs/oc/oms/v1/saveBill', params), // 保存
  backAudit: params => $network.post('/p/cs/oc/oms/v1/backAudit', params), // 零售发货单反审核
  audit: params => $network.post('/p/cs/oc/oms/v1/audit', params), // 零售发货单审核
  // queryPhyWareHouseList: params => $network.post('/p/cs/md/v1/phyWarehouse/queryPhyWareHouseList', params), // 零售发货单-初始化发货仓库options
  queryPhyWareHouseList: params =>
    $network.post('/p/cs/md/v1/phyWarehouse/queryPhyWareHouseList', params, {
      serviceId: 'r3-cp'
    }), // 零售发货单-初始化发货仓库options
  getOcBOrderItemBySkuECode: params =>
    $network.post('/p/cs/oc/oms/v1/getOcBOrderItemBySkuECode', params), // 零售发货单-新增/复制-根据sku编码新增订单明细
  initObjectList: params => $network.post('/p/cs/oc/oms/v1/initObject', params), // 零售发货单列表(包裹详情,商品详情表头查询)
  queryObjectList: params => $network.post('/p/cs/oc/oms/v1/queryObject', params), // 零售发货单列表(包裹详情,商品详情明细查询)

  createReturnOrderToWms: params =>
    $network.post('/p/cs/oc/oms/v1/returnOrder/createReturnOrderToWms', params), // 退货单-手工通知WMS新建
  cancelReturnOrderFromWms: params =>
    $network.post('/p/cs/oc/oms/v1/returnOrder/cancelReturnOrderFromWms', params), // 退货单-手工通知WMS撤回
  returnConfirmCheck: params =>
    $network.post('/p/cs/oc/oms/v1/returnOrder/returnConfirmCheck', params), //退货确认检查接口
  checkReturnOrderBeforeLogistics: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/checkOrderBeforeLogistics', params), //改退回物流检查接口
  checkReturnOrderBeforeWarehouse: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/checkOrderBeforeWarehouse', params), //改退回仓库检查接口
  updateReturnWarehouse: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/updateWarehouse', params), //改退回仓库接口
  updateReturnLogistics: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/updateLogistics', params), //改退回物流接口
  returnConfirm: params => $network.post('/p/cs/oc/oms/v1/returnOrder/returnConfirm', params), //退货确认功能
  splitCheckOrder: params => $network.post('/p/cs/oc/oms/v1/splitCheckOrder', params), //指定商品拆单校验
  queryFlagList: params => $network.post('/p/cs/QueryList', params), //标记列表
  saveLable: params => $network.post('/p/cs/oc/oms/v1/saveLable', params), //标签管理
  addOrderLable: params => $network.post('/p/cs/oc/oms/v1/addOrderLable', params), //添加标记
  cancelOrderLable: params => $network.post('/p/cs/oc/oms/v1/cancelOrderLable', params), //取消标记
  orderExport: params => $network.post('/p/cs/oc/oms/v1/export', params), //订单列表里的导入功能
  updateDeliveryTime: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocborder/updateDeliveryTime', params), // 零售列表-修改预计发货时间

  querySgStorage: params => $network.post('/p/cs/oc/b/oms/v1/ocborder/querySgStorage', params), // 列表-商品详情-查库存
  // orderDeliveryUrgent: params => $network.post('/p/cs/oc/b/oms/v1/ocborder/orderDeliveryUrgent', params), // 加急发货接口
  orderDeliveryUrgent: params => $network.post('/api/cs/oc/oms/v1/orderDeliveryUrgent', params), // 加急发货接口
  checkOrderDeliveryUrgent: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocborder/checkOrderDeliveryUrgent', params), // 加急发货检查接口
  returnSaveBill: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/returnSaveBill', params, {
      serviceId: 'r3-oc-oms'
    }), // 退换货单Add-save
  getReturnItemBySourceCode: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/getReturnItemBySourceCode', params, {
      serviceId: 'r3-oc-oms'
    }), // 退换货单-原始订单编号-查找明细
  objectTableItem: params => $network.post('/p/cs/objectTableItem', params), // 退款分类-退款分类描述
  getReturnExchangeItemBySkuECode: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/getReturnExchangeItemBySkuECode', params, {
      serviceId: 'r3-oc-oms'
    }), // 获取对应sku的商品
  getALlOrderReturnAndItemInfo: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocbreturnorder/getALlOrderReturnAndItemInfo', params), // 退货单/换货单明细
  queryExtraReturnOrder: params =>
    $network.post('/p/cs/oc/oms/v1/ocborder/queryExtraReturnOrder', params), // 额外退款单-主表 原平台订单查询
  queryExtraReturnOrderItem: params =>
    $network.post('/p/cs/oc/oms/v1/ocborder/queryExtraReturnOrderItem', params), // 额外退款单-主表 订单明细查询
  ocBCompensateOrder: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocBCompensateOrder/queryOrderList', params), // 赔付单-主表 订单明细查询
  payQueryProList: params =>
    $network.post('/p/cs/oc/b/oms/v1/ocBCompensateOrder/queryProList', params), // 赔付单-子表-新增明细
  paySaveApi: params => $network.post('/p/cs/oc/b/oms/v1/ocBCompensateOrder/save', params), // 赔付单-保存
  extraSaveApi: params => $network.post('/p/cs/oc/oms/v1/refundExtra/save', params), // 赔付单-保存
  payableAdjustmentCreate: params => $network.post('/api/cs/oc/oms/payableAdjustmentCreate', params), // 生成赔付单
  confirm: params => $network.post('/api/cs/oc/oms/v1/returnOrder/confirm', params), // 退换货单-确认
  queryLogisticsCode: params => $network.post('/api/cs/oc/oms/v1/returnOrder/queryLogisticsCode', params), // 退换货单-查询退款物流单号

  retailBusinessTargetDetailQuery: params =>
    $network.post('/p/cs/retailBusinessTargetDetailQuery', params), // 营业指标明细(天)-查询
  retailBusinessTargetSalerQuery: params =>
    $network.post('/p/cs/retailBusinessTargetSalerQuery', params), // 营业指标明细(店员)-查询
  retailBusinessTargetSave: params =>
    $network.post('/p/cs/retailBusinessTargetDetailQuery', params), // 营业指标明细(天/店员)-保存

  queryOmsWarehouse: params => $network.post('/api/cs/oc/oms/v1/queryOmsWarehouse', params),
  queryOmsShopStorage: params => $network.post('/api/cs/oc/oms/v1/queryOmsShopStorage', params), // 查询聚合仓及其关联的实体仓
  updateSendTime: params => $network.post('/api/cs/vip/delivery/v1/updateSendTime', params), // 唯品会入库单-详情-修改发货时间
  inStoreByReturnOrder: params => $network.post('/api/cs/oc/oms/v1/inStoreByReturnOrder', params),// 一键入库
  omsQueryData: params => $network.post('/api/cs/oc/oms/queryData', params),// 寻仓寻物流 - 主表
  omsConfirm: params => $network.post('/api/cs/oc/oms/confirm', params),// 寻仓寻物流动作定义\占用结果查询动作定义
  updateBusinessType: params => $network.post('/api/cs/oc/oms/v1/updateBusinessType', params),
  terminateWarehousing: params => $network.post('/api/cs/oc/oms/v1/returnOrder/terminateWarehousing', params),
  orderBeforeCheck: params => $network.post('/api/cs/oc/oms/v1/orderBeforeCheck', params),
  confirmSplitOrderByRow: params => $network.post('/api/cs/oc/oms/v1/confirmSplitOrderByRow', params), // 按行拆单
  confirmSplitOrderByOne: params => $network.post('/api/cs/oc/oms/v1/confirmSplitOrderByOne', params), // 一单一货
  againDistributionLogistics: params => $network.post('/api/cs/oc/oms/v1/againDistributionLogistics', params), // 重新寻物流
  updateShop: params => $network.post('/api/cs/oc/oms/pre/v1/updateShop', params), // 订单导入-修改店铺
  serialTransfer: params => $network.post('/api/cs/oc/oms/pre/v1/serial/transfer', params), // 订单导入-按流水转入
  syncPlatformRefundStatus: params => $network.post('/api/cs/oc/oms/v1/syncPlatformRefundStatus', params), // 同步通用平台状态
  queryReturnReason: params => $network.post('/api/cs/oc/oms/v1/queryReturnReason', params),
  checkCopyDistribution: params => $network.post('/api/cs/vip/distribution/v1/checkCopyDistribution', params),
  querySkuList: params => $network.post('/api/cs/vip/oc_b_vipcom_return_po/v1/querySkuList', params), // 唯品会退货单-条码明细

  returnOrderDownload: params => $network.post('/api/cs/ip/returnOrderDownload', params),
  noticeSendInit: params => $network.post('/api/cs/dc/v1/order/noticeSendInit', params),
  noticeSendSelect: params => $network.post('/api/cs/dc/v1/order/noticeSendSelect', params),
  confirmNoticeSend: params => $network.post('/api/cs/dc/v1/order/confirmNoticeSend', params),
}

